export const Menu = {}

export default Menu
